export var ErrorCode;
(function (ErrorCode) {
    // Generic
    ErrorCode["INTERNAL_ERROR"] = "INTERNAL_ERROR";
    ErrorCode["BAD_REQUEST"] = "BAD_REQUEST";
    ErrorCode["UNAUTHORIZED"] = "UNAUTHORIZED";
    ErrorCode["FORBIDDEN"] = "FORBIDDEN";
    ErrorCode["NOT_FOUND"] = "NOT_FOUND";
    ErrorCode["SESSION_EXPIRED"] = "SESSION_EXPIRED";
    // Identity / Auth
    ErrorCode["IDENTITY_EXPIRED"] = "IDENTITY_EXPIRED";
    ErrorCode["IDENTITY_TAKEN"] = "IDENTITY_TAKEN";
    ErrorCode["INVALID_PHRASE"] = "INVALID_PHRASE";
    ErrorCode["INVALID_SIGNATURE"] = "INVALID_SIGNATURE";
    ErrorCode["RATE_LIMIT_EXCEEDED"] = "RATE_LIMIT_EXCEEDED";
    // Identity Validation
    ErrorCode["INVALID_USERNAME_FORMAT"] = "INVALID_USERNAME_FORMAT";
    ErrorCode["MISSING_CREDENTIALS"] = "MISSING_CREDENTIALS";
    ErrorCode["NOT_RESERVED"] = "NOT_RESERVED";
    ErrorCode["INVALID_CREDENTIAL_FORMAT"] = "INVALID_CREDENTIAL_FORMAT";
    ErrorCode["INVALID_STATE"] = "INVALID_STATE";
    // Billing
    ErrorCode["PAYMENT_FAILED"] = "PAYMENT_FAILED";
    ErrorCode["SERVICE_UNAVAILABLE"] = "SERVICE_UNAVAILABLE";
    ErrorCode["GONE"] = "GONE";
})(ErrorCode || (ErrorCode = {}));
export class DomainError extends Error {
    code;
    cause;
    constructor(code, message, cause) {
        super(message);
        this.code = code;
        this.cause = cause;
        this.name = 'DomainError';
    }
}
//# sourceMappingURL=errors.js.map